import { CardList } from '@/app/components/cards/CardList';
import type { ImportedInvalidClient } from '@/types/clientDetailsApiTypes';
import { INVALID_ROW_FIELDS } from '../../consts/invalidRowFields';

interface InvalidCardsProps {
  rows: ImportedInvalidClient[];
}

const getRowKey = (_row: ImportedInvalidClient, index: number) => index;

const renderInvalidRow = (row: ImportedInvalidClient, index: number) => (
  <div className="flex flex-col gap-4 rounded-md border border-grey-200 p-4">
    <div className="flex items-start gap-4">
      <div className="flex w-25 flex-col justify-center gap-0.5">
        <span className="font-inter text-xs leading-normal text-grey-700">Row</span>
        <span className="font-inter text-xs leading-normal text-blue-900">{index + 1}</span>
      </div>

      <div className="flex min-w-0 flex-1 flex-col justify-center gap-0.5">
        <span className="font-inter text-xs leading-normal text-grey-700">Issue</span>
        <div className="flex flex-col gap-1 rounded-md bg-red-500/10 px-2 py-0.5">
          {Object.entries(row.errors).map(([field, messages]) => (
            <span key={field} className="font-inter text-xs leading-[120%] text-red-500">
              {messages.join(', ')}
            </span>
          ))}
        </div>
      </div>
    </div>

    <div className="h-px w-full bg-grey-200" aria-hidden />

    <div className="flex items-start gap-1.5">
      {INVALID_ROW_FIELDS.map(({ label, getValue }) => (
        <div key={label} className="flex min-w-0 flex-1 flex-col justify-center gap-0.5">
          <span className="font-inter text-xs leading-normal text-grey-700">{label}</span>
          <span className="truncate font-inter text-xs leading-normal text-blue-900">{getValue(row) ?? '—'}</span>
        </div>
      ))}
    </div>
  </div>
);

export function InvalidCards({ rows }: InvalidCardsProps) {
  return <CardList<ImportedInvalidClient> items={rows} getKey={getRowKey} renderCard={renderInvalidRow} />;
}
